<template>
    <section class="inline large">
        <div class="grid fixed fixed-max-sm xs-grid-cols-1 gap-3">
            <div class="text-center">
                <div class="f7 text-uppercase"><b>{{brokerage.displayName}} BROKERAGE</b></div>
                <h2 class="f3 text-bold">Our Team</h2>
            </div>
            <div>
                <div class="grid xs-grid-cols-3 sm-grid-cols-4 ">
                    <div v-for="(agent, i) in brokerage.agents" :key="i">
                            <a class="link" :href="glb.appUrl + agent.profileUrl">
                                <mvtCardAgent :simple="true" :data="{ ...agent, agentImage: agent.agentImage }"></mvtCardAgent>
                            </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script src="./brokerage-agent.js"></script>
<style lang="scss">
@use './brokerage-agent.scss' as *;
</style>
